import CitySEOHead from "@/components/feature/CitySEOHead";
import EdinaHeroSection from "./components/HeroSection";
import EdinaStickyNav from "./components/StickyNav";
import EdinaProcessingTimeSection from "./components/ProcessingTimeSection";
import EdinaServicesSection from "./components/ServicesSection";
import EdinaLocalAreaSection from "./components/LocalAreaSection";
import EdinaTravelTimingSection from "./components/TravelTimingSection";
import EdinaDestinationsSection from "./components/DestinationsSection";
import EdinaTestimonialsSection from "./components/TestimonialsSection";
import EdinaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import EdinaComparisonSection from "./components/ComparisonSection";
import EdinaMistakesSection from "./components/MistakesSection";
import EdinaHowItWorksSection from "./components/HowItWorksSection";
import EdinaFAQSection from "./components/FAQSection";
import EdinaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import EdinaFinalCTA from "./components/FinalCTA";
import { faqs } from "./components/FAQSection";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function EdinaPage() {
  return (
    <>
      <CitySEOHead
        city="Edina"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/edina"
        title="Emergency Passport Edina, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Edina, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Galleria executives, 50th and France professionals, Edina schools, and all of Hennepin County southwest metro."
        geoPlacename="Edina, Minnesota"
        geoPosition="44.9096;-93.3499"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
        keywords="expedited passport Edina MN, emergency passport Edina, passport renewal Hennepin County"
      />
      <div className="font-sans">
        <EdinaHeroSection />
        <EdinaStickyNav />
        <EdinaProcessingTimeSection />
        <EdinaServicesSection />
        <EdinaLocalAreaSection />
        <EdinaTravelTimingSection />
        <EdinaDestinationsSection />
        <EdinaTestimonialsSection />
        <EdinaAcceptanceFacilitiesSection />
        <EdinaComparisonSection />
        <EdinaMistakesSection />
        <EdinaHowItWorksSection />
        <EdinaFAQSection />
        <EdinaHelpfulResourcesSection />
        <EdinaFinalCTA />
      </div>
    </>
  );
}